<div class="buy-rent-container" *ngIf="item.itemType == 'movie'">

  <span *ngIf="hasBuyPrices()" class="buy-rent-btn" [class.price-selected]="buySelected == true"
  (click)="buyClick()">{{getString('buy')}}</span>

  <span *ngIf="!hasBuyPrices()" class="linethru buy-rent-btn">{{getString('buy')}}</span>

  <span *ngIf="shouldDisplayRentalPrice()"> | </span>

  <span *ngIf="shouldDisplayRentalPrice() && hasRentalPrices()" class="buy-rent-btn" [class.price-selected]="buySelected == false"
  (click)="rentClick()">{{getString('rent')}}</span>

  <span *ngIf="shouldDisplayRentalPrice() && !hasRentalPrices()" class="linethru buy-rent-btn">{{getString('rent')}}</span>
</div>

<div *ngIf="storeIsAmazon()" class="amazon-price-text">{{getString('amazonDotComPrice')}}</div>

<div class="detail-prices-container">

  <div class="container" *ngIf="hasSdPrice() && !hasHdPrice()">
    <div class="line-container">
      <div class="logos-container">
        <div class="quality-logo"></div>
        <img alt="" *ngIf="getPriceSdIsBest() == 1" class="arrow-icon" src="./assets/images/arrow_yellow.png">
        <img alt="" *ngIf="getPriceSdIsBest() == 0 && getPriceSdDropIndicator() == -1" class="arrow-icon" src="./assets/images/arrow_green.png">
        <img alt="" *ngIf="getPriceSdIsBest() == 0 && getPriceSdDropIndicator() == 1" class="arrow-icon" src="./assets/images/arrow_red.png">
      </div>
      <div class="price-container">
        <div class="price" [class.preorder]="item.isPreorder == 1">{{getSdPrice()}}</div>
        <div class="price-before">{{getSdPriceBefore()}}</div>
        <div *ngIf="getPriceSdIsBest() == 1" class="best-price-text">{{getString('bestPrice')}}</div>
        <div *ngIf="getPriceSdIsLowest() == 1 && getPriceSdIsBest() == 0" class="lowest-price-text">{{getString('lowestPrice')}}</div>
      </div>
    </div>
  </div>

  <div class="container" *ngIf="hasHdPrice()">
    <div class="line-container">
      <div class="logos-container">
        <img alt="" *ngIf="item.has4K == null || item.has4K == 0 || has4kPrice()" class="quality-logo" src="./assets/images/hd-icon.png">
        <img alt="" *ngIf="item.has4K == 1 && !has4kPrice()" class="quality-logo" src="./assets/images/4k-icon.png">

        <img alt="" *ngIf="getPriceHdIsBest() == 1" class="arrow-icon" src="./assets/images/arrow_yellow.png">
        <img alt="" *ngIf="getPriceHdIsBest() == 0 && getPriceHdDropIndicator() == -1" class="arrow-icon" src="./assets/images/arrow_green.png">
        <img alt="" *ngIf="getPriceHdIsBest() == 0 && getPriceHdDropIndicator() == 1" class="arrow-icon" src="./assets/images/arrow_red.png">
      </div>
      <div class="price-container">
        <div class="price" [class.preorder]="item.isPreorder == 1">{{getHdPrice()}}</div>
        <div class="price-before">{{getHdPriceBefore()}}</div>
        <div *ngIf="getPriceHdIsBest() == 1" class="best-price-text">{{getString('bestPrice')}}</div>
        <div *ngIf="getPriceHdIsLowest() == 1 && getPriceHdIsBest() == 0" class="lowest-price-text">{{getString('lowestPrice')}}</div>
      </div>
    </div>
  </div>

  <div class="container" *ngIf="has4kPrice()">
    <div class="line-container">
      <div class="logos-container">
        <img alt="" class="quality-logo" src="./assets/images/4k-icon.png">

        <img alt="" *ngIf="getPrice4kIsBest() == 1" class="arrow-icon" src="./assets/images/arrow_yellow.png">
        <img alt="" *ngIf="getPrice4kIsBest() == 0 && getPrice4kDropIndicator() == -1" class="arrow-icon" src="./assets/images/arrow_green.png">
        <img alt="" *ngIf="getPrice4kIsBest() == 0 && getPrice4kDropIndicator() == 1" class="arrow-icon" src="./assets/images/arrow_red.png">
      </div>
      <div class="price-container">
        <div class="price" [class.preorder]="item.isPreorder == 1">{{get4kPrice()}}</div>
        <div class="price-before">{{get4kPriceBefore()}}</div>
        <div *ngIf="getPrice4kIsBest() == 1" class="best-price-text">{{getString('bestPrice')}}</div>
        <div *ngIf="getPrice4kIsLowest() == 1 && getPrice4kIsBest() == 0" class="best-price-text">{{getString('bestPrice')}}</div>
      </div>
    </div>
  </div>

  <div class="container" *ngIf="hasPrice()">
    <div class="line-container">
      <div class="arrow-container">
        <img alt="" *ngIf="getPriceIsBest() == 1" class="arrow-icon" src="./assets/images/arrow_yellow.png">
        <img alt="" *ngIf="getPriceIsBest() == 0 && getPriceDropIndicator() == -1" class="arrow-icon" src="./assets/images/arrow_green.png">
        <img alt="" *ngIf="getPriceIsBest() == 0 && getPriceDropIndicator() == 1" class="arrow-icon" src="./assets/images/arrow_red.png">
      </div>
      <div class="price-container">
        <div class="price" [class.preorder]="item.isPreorder == 1">{{getPrice()}}</div>
        <div class="price-before">{{getPriceBefore()}}</div>
        <div *ngIf="getPriceIsBest() == 1" class="best-price-text">{{getString('bestPrice')}}</div>
        <div *ngIf="getPriceIsLowest() == 1 && getPriceIsBest() == 0" class="lowest-price-text">{{getString('lowestPrice')}}</div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="storeIsAmazon()" class="amazon-price-text">{{getString('asOf')}} {{getTimeStamp()}}
  <div (click)="showAmazonPriceMoreInfo()" class="more-info">{{getString('moreInfo')}}</div>
</div>


<app-modal #amazonPriceInfo [okModal]="true">
  {{getString('amazonPriceInfo')}}
</app-modal>
